export class SeatBlockedApiModel {
  id: string;

  seatId: string;
}
